<template>
    <div class="MyOrder">
        <div class="MyOrderBox">
            <div class="Img">
                <img src="@/assets/images/Order/MyOrder.png" />
            </div>
            <!-- 查询 -->
            <el-form :inline="true" :model="MyOrderForm" style="text-align: left;" class="demo-form-inline">
                <el-form-item label="订单状态：" style="margin-right: 30px;">
                    <el-select v-model="MyOrderForm.status" clearable placeholder="请选择">
                        <el-option
                            v-for="item in StatusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="下单时间：" style="margin-right: 30px;">
                    <el-date-picker 
                        v-model="date"
                        @change="handleChangeDate"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right"
                        :picker-options="pickerOptions"
                        unlink-panels></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜 索</el-button>
                </el-form-item>
            </el-form>
            <!-- table -->
            <el-table :data="MyOrderList" :header-cell-style="HeaderCellStyle" :cell-style="CellStyle" v-loading="listLoading" height="655" border style="width: 100%;">
                <el-table-column prop="orderCode" label="订单编号" width="210" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="goods" label="兑换商品" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div class="GoodsBox">
                            <div class="image" v-if="scope.row.mainAttachment && scope.row.mainAttachment.length > 0">
                                <img :src="scope.row.httpPath" />
                            </div>
                            <div class="info">
                                <div class="title">{{ scope.row.commodityTitle }}</div>
                                <div class="desc">{{ scope.row.commodityName }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderdNums" label="数量" width="80" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="createdTime" label="下单时间" width="120" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="orderIntegral" label="消耗积分" width="80" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="logisticsCompany" label="物流信息" width="160" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 25 || scope.row.status === 30">{{ scope.row.logisticsCompany }} <br /> {{ scope.row.courierNumber }}</span>
                        <span v-else>暂无物流信息</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="120" :show-overflow-tooltip="true">
                    <!-- 10 待支付  15  处理中   20 待发货  25 已发货  30 已完成  50 已取消 -->
                    <template slot-scope="scope">
                        <span>{{ GetStatus(scope.row.status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" :show-overflow-tooltip="true">
                    <template slot-scope="scope" v-if="scope.row.status === 10">
                        <div style="margin-bottom: 12px;">
                            <el-button type="primary" size="small" style="background-color: #409eff; border-color: #409eff;" @click="handleImmediatelyChange(scope.row)">立即兑换</el-button>
                        </div>
                        <div>
                            <el-button type="danger" size="small" @click="handleCancelAnOrder(scope.row)">取消订单</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <!--  v-loading="listLoading" -->
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="MyOrderForm.currentPage"
                    background
                    :page-size="MyOrderForm.pageSize"
                    layout="total, prev, pager, next"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="total">
                </el-pagination>
            </div>
            <!-- 兑换说明 -->
            <Instructions />
        </div>
    </div>
</template>

<script>
import * as API from '@/api/user';
import Instructions from "@/views/components/Instructions";
import { getCommonToken } from '@/utils/auth';
export default {
    name: 'MyOrder',
    components: {
        Instructions
    },
    data() {
        return {
            MyOrderForm: {
                pageSize: 6,
                currentPage: 1
            },
            StatusOptions: [
                { label: '全 部', value: '' },
                { label: '待支付', value: '10' },
                { label: '处理中', value: '15' },
                { label: '待发货', value: '20' },
                { label: '已发货', value: '25' },
                { label: '已完成', value: '30' },
                { label: '已取消', value: '50' }
            ],
            // 时间
            date: [],
            // tableList
            MyOrderList: [],
            total: 0,
            listLoading: false,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }],
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6;//如果不包括今天。就是return time.getTime() > Date.now() - 24*3600*1000;
                }
            }
        }
    },
    methods: {
        // 查询
        handleSearch() {
            this.GetList();
        },
        // 取消订单
        handleCancelAnOrder(row) {
            this.$confirm('是否取消次商品?', '取消确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                API.cancelPointsmallOrder(row.orderCode).then(res => {
                    if (res.code === 20000) {
                        this.$message({ type: 'success', message: '取消成功!'});
                        this.$router.push({ path: '/Cancel' });
                        this.GetList();
                    }
                })
            }).catch(() => {});
        },
        // 立即兑换
        handleImmediatelyChange(row) {
            this.$confirm('是否兑换该商品?', '兑换确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                API.payPointsmallOrder(row.orderCode).then(res => {
                    if (res.code === 20000) {
                        this.$message({ type: 'success', message: '兑换成功!'});
                        this.$router.push({ path: '/ForSuccessful', query: { orderIntegral: res.data.orderIntegral, paydetail: JSON.stringify(res.data.stdPointsShipAddress) } });
                        this.GetList();
                    }
                })
            }).catch(() => {});
        },
        // 下单时间
        handleChangeDate(val) {
            if(val) {
                this.$set(this.MyOrderForm, 'createdStartTime', val[0]);
                this.$set(this.MyOrderForm, 'createdEndTime', val[1]);
            } else {
                this.$set(this.MyOrderForm, 'createdStartTime', null);
                this.$set(this.MyOrderForm, 'createdEndTime', null);
            }
        },
        // 分页改变
        handleCurrentChange(val) {
            this.MyOrderForm.currentPage = val;
            this.GetList();
        },
        // 获取订单列表
        GetList() {
            this.listLoading = true;
            this.$set(this.MyOrderForm, "xdkh", getCommonToken("MOBILE"));
            API.getPointsOrder(this.MyOrderForm).then(res => {
                this.listLoading = false;
                if(res.code === 20000) {
                    this.MyOrderList = res.data.items;
                    this.total = res.data.total;
                }
            }).catch(() => {
                this.listLoading = false;
            });
        },
        // 0  创建  10 待支付  15  处理中   20 待发货  25 已发货  30 已完成  50 已取消
        GetStatus(status) {
            let str;
            switch(status) {
                case 0:
                    str = "创建";
                    break;
                case 10:
                    str = "待支付";
                    break;
                case 15:
                    str = "处理中";
                    break;
                case 20:
                    str = "待发货";
                    break;
                case 25:
                    str = "已发货";
                    break;
                case 30:
                    str = "已完成";
                    break;
                case 50:
                    str = "已取消";
                    break;
            }
            return str;
        },
        // 表头
        HeaderCellStyle () {
            // console.log(row, column, rowIndex, columnIndex);
            return 'text-align: center; color: #ffffff; background: #3880ca;';
        },
        // 单元格
        CellStyle () {
            // console.log(row, column, rowIndex, columnIndex);
            return 'text-align: center; color: #000000;';
        }
    },
    mounted() {
        console.log("Mobile", getCommonToken("MOBILE"))
        this.GetList();
    }
}
</script>

<style scoped>
.MyOrder {
    border-top: 1px solid #989797;
    margin-top: 12px;
    overflow: hidden;
    margin-bottom: 200px;
}
.MyOrder .MyOrderBox {
    width: 1280px;
    margin: 0 auto;
}
.MyOrder .MyOrderBox .Img {
    margin-top: 60px;
    overflow: hidden;
    text-align: left;
    margin-bottom: 60px;
}
.MyOrder .MyOrderBox /deep/ .el-form--inline .el-form-item__label {
    font-weight: 600;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox {
    overflow: hidden;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .image {
    width: 58px;
    height: 58px;
    float: left;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .image img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info {
    float: left;
    width: 292px;
    overflow: hidden;
    text-align: left;
    margin-left: 16px;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info .title {
    font-weight: 600;
    margin-bottom: 10px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info .desc {
    font-size: 12px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.MyOrder .MyOrderBox .page {
    text-align: right;
    margin-top: 20px;
}
.MyOrder .MyOrderBox .page  /deep/ .el-pagination.is-background .btn-next, 
.MyOrder .MyOrderBox .page  /deep/ .el-pagination.is-background .btn-prev {
  padding: 0 5px;
}
</style>